import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// IMPORTANT:
// This component must be defined at module scope (not inside App),
// otherwise React will treat it as a new component type on every App render,
// causing route elements to unmount/remount and re-fire useEffects (duplicate API calls).
export default function GuardedElement({
  prefix,
  element,
  accessLoaded,
  allowedPrefixes,
  lastDeniedPath,
  onDenied,
  lastAllowedPath,
  shouldRedirectOnDenied,
  fallbackAllowedPath,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const getFullPath = React.useCallback(() => {
    const search = location.search || '';
    const hash = location.hash || '';
    return `${location.pathname}${search}${hash}`;
  }, [location.pathname, location.search, location.hash]);

  if (!accessLoaded) return element;

  const lowerCurrent = (location.pathname || '').toLowerCase();
  const p = (prefix || '').toLowerCase();
  const allowed = allowedPrefixes.some((ap) => (ap || '').toLowerCase() === p);

  // If not allowed for this section, prevent mounting and bounce back
  if (!allowed && (lowerCurrent === p || lowerCurrent.startsWith(p + '/'))) {
    const full = getFullPath();
    if (lastDeniedPath !== full) {
      onDenied?.(full);
    }

    if (shouldRedirectOnDenied) {
      const dest = lastAllowedPath || sessionStorage.getItem('lastAllowedPath') || fallbackAllowedPath;
      if (dest && full !== dest) {
        navigate(dest, { replace: true });
      }
    }

    return null;
  }

  return element;
}


